/* eslint-disable camelcase */
import { CriticalDatasetLabels, DetectorDirection } from '../../enum'
import Vuetify from '../../plugins/vuetify'

const _t = (text) => Vuetify.framework.lang.t(text)

export class DetectorPhoneEntry {
  constructor ({ phone_front = false, phone_around_ear = DetectorDirection.NONE, phone_kept_by_shoulder = DetectorDirection.NONE, message_phone_visible = false } = {}) {
    this.phoneFront = phone_front // boolean
    this.phoneAroundEar = phone_around_ear // enums.DetectorDirection
    this.phoneKeptByShoulder = phone_kept_by_shoulder // enums.DetectorDirection
    this.messagePhoneVisible = message_phone_visible // boolean
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      phone_front: this.phoneFront,
      phone_around_ear: this.phoneAroundEar,
      phone_kept_by_shoulder: this.phoneKeptByShoulder,
      message_phone_visible: this.messagePhoneVisible
    }
  }

  get textRepresentation () {
    const result = []

    if (this.phoneFront) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.phoneFrontDataset`))
    }

    if (this.phoneAroundEar !== DetectorDirection.NONE) {
      result.push(`${_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.phoneAroundEarDataset`)} ${_t(`$vuetify.criticalDataset.enums.DetectorDirection.${this.phoneAroundEar}`)}`)
    }

    if (this.phoneKeptByShoulder !== DetectorDirection.NONE) {
      result.push(`${_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.phoneKeptByShoulderDataset`)} ${_t(`$vuetify.criticalDataset.enums.DetectorDirection.${this.phoneKeptByShoulder}`)}`)
    }

    if (this.messagePhoneVisible) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.messagePhoneVisibleDataset`))
    }

    return result.map(item => ({
      item,
      color: 'black',
      type: CriticalDatasetLabels.PHONE_DETECTOR
    }))
  }
}
